import { Component } from '@angular/core';

@Component({
  selector: 'app-top-banner',
  templateUrl: './top-banner.component.html',
  styleUrls: ['./top-banner.component.scss']
})
export class TopBannerComponent {
  text = 'Tracey – Powered by Stotinka';
  items = Array(30).fill(0);
}
